import { createContext } from "react";

export const ImageViewContext = createContext();

export const ImageViewProvider = ImageViewContext.Provider;
